import { ReactComponent as CloseIcon } from '../svgs/close.svg'
import { ReactComponent as Alert} from '../svgs/cir_alert.svg'

const defaultChildren:any = null

const CookieButton = ({
    onRemoved=()=>{},
    bgColor="rgb(103, 158, 255)",
    color="#ffffff",
    alert=false,
    children=defaultChildren,
    edit=true}) => {
    if (!bgColor) bgColor = "rgb(103, 158, 255)"
    if (!color) color = "#ffffff"
    
    return <div className="cookie" style={{backgroundColor:bgColor,color:color}}>
        {alert && <Alert fill="rgb(255, 162, 0)" height={20} width={20} style={{padding:"0px 3px 2px 2px"}} />}
        {children}
        {edit && <button 
            onClick={onRemoved}
            style={{padding:0,border:"none",backgroundColor:"rgb(255 255 255 / 0%)"}}>
            <CloseIcon stroke={color} style={{padding:"0px 0px 2px 3px"}} />
        </button>}
    </div>
}

export default CookieButton